module.exports = __webpack_public_path__ + "img/eggs_salmon_avo_side.4286e46f.jpg";